import { ZodType } from 'zod';

export function nullishDefault<Z extends ZodType, T>(type: Z, defaultValue: T) {
    return type.nullish().transform((value) => value ?? defaultValue);
}
